export const invertedMessages = {
  On: 'CERTS_LIST_ON',
  Off: 'CERTS_LIST_OFF',
};
